"use client";

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';
import { AIUsageSummary } from './AIUsageSummary';
import { AIConversationsList } from './AIConversationsList';
import { AIUserUsageTable } from './AIUserUsageTable';
import { AIUsageCharts } from './AIUsageCharts';

export function AIUsageDashboard() {
  const [timeRange, setTimeRange] = useState<'24h' | '7d' | '30d' | 'all'>('7d');

  return (
    <div className="space-y-6">
      {/* Spec Management Navigation */}
      <div className="flex gap-2 border-b pb-4">
        <Button asChild variant="ghost" size="sm">
          <Link to="/admin/ai-prompts">
            <Settings className="w-4 h-4 mr-2" />
            AI System Prompts
          </Link>
        </Button>
      </div>
      
      <AIUsageSummary timeRange={timeRange} onTimeRangeChange={setTimeRange} />
      
      <Tabs defaultValue="conversations" className="space-y-4">
        <TabsList>
          <TabsTrigger value="conversations">Conversations</TabsTrigger>
          <TabsTrigger value="users">User Usage</TabsTrigger>
          <TabsTrigger value="charts">Analytics</TabsTrigger>
        </TabsList>
        
        <TabsContent value="conversations" className="space-y-4">
          <AIConversationsList timeRange={timeRange} />
        </TabsContent>
        
        <TabsContent value="users" className="space-y-4">
          <AIUserUsageTable />
        </TabsContent>
        
        <TabsContent value="charts" className="space-y-4">
          <AIUsageCharts timeRange={timeRange} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
